import { compose, lifecycle } from 'recompose';
import { addMetaOgTagToHead } from '../Helper';
import config from '../../../config';
import { getStoreName } from '../../Store/Store.APP_ENV.js';

const META_DESCRIPTION = 'description';
const META_OG_TITLE_TAG = 'og:title';
const META_OG_SITE_NAME_TAG = 'og:site_name';
const META_OG_DESCRIPTION_TAG = 'og:description';
const META_OG_IMAGE_TAG = 'og:image';
const META_OG_TYPE_TAG = 'og:type';

const createOgTitleTag = () => {
  const ogTitleTag = document.querySelector(`meta[property="${META_OG_TITLE_TAG}"]`);
  if (ogTitleTag) {
    ogTitleTag.setAttribute('content', document.title);
  } else {
    addMetaOgTagToHead({ property: META_OG_TITLE_TAG, content: document.title });
  }
}

const createOgSiteNameTag = (storeName) => {
  const ogSiteNameTag = document.querySelector(`meta[property="${META_OG_SITE_NAME_TAG}"]`);
  if (ogSiteNameTag) {
    ogSiteNameTag.setAttribute('content', storeName);
  } else {
    addMetaOgTagToHead({ property: META_OG_SITE_NAME_TAG, content: storeName });
  }
}

const createOgDescriptionTag = () => {
  const descriptionElement = document.querySelector(`meta[name="${META_DESCRIPTION}"]`);
  const description = descriptionElement && descriptionElement.content ? descriptionElement.content : '';
  const ogDescriptionTag = document.querySelector(`meta[property="${META_OG_DESCRIPTION_TAG}"]`);
  if (ogDescriptionTag) {
    ogDescriptionTag.setAttribute('content', description);
  } else {
    addMetaOgTagToHead({ property: META_OG_DESCRIPTION_TAG, content: description });
  }
}

const createOgImageTag = () => {
  const ogImageTag = document.querySelector(`meta[property="${META_OG_IMAGE_TAG}"]`);
  if (!ogImageTag) {
    addMetaOgTagToHead({ property: META_OG_IMAGE_TAG, content: `${config.s3BucketUrl}/assets/general/photobook-1080.jpeg` });
  }
};

const createOgTypeTag = () => {
  const ogTypeTag = document.querySelector(`meta[property="${META_OG_TYPE_TAG}"]`);
  if (!ogTypeTag) {
    addMetaOgTagToHead({ property: META_OG_TYPE_TAG, content: 'website' });
  }
};

export const withOgTag = compose(
  lifecycle({
    componentDidMount() {
      if (window.location.href.indexOf('/ephotobook/preview') === -1) {
        createOgImageTag();
        createOgTypeTag();
        createOgSiteNameTag(getStoreName());

        const observerConfig = {
          attributes: true,
          childList: true,
        };

        const titleElement = document.querySelector('title');
        const titleObserver = new MutationObserver(createOgTitleTag);
        titleObserver.observe(titleElement, observerConfig);

        const descriptionElement = document.querySelector(`meta[name="${META_DESCRIPTION}"]`);
        const descriptionObserver = new MutationObserver(createOgDescriptionTag);
        descriptionObserver.observe(descriptionElement, observerConfig);
      }
    }
  })
);



// WEBPACK FOOTER //
// ./src/Common/Helmet/WithOgTag.js